import { render, staticRenderFns } from "./ProductsMultiselectModal.vue?vue&type=template&id=1902db1a&"
import script from "./ProductsMultiselectModal.vue?vue&type=script&lang=js&"
export * from "./ProductsMultiselectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports